import STRINGS from '../../common/strings/strings';
import Helper from '../../apis/Helper';

export function validationProposalInfoForm(data, fieldName) {
    const { projectName, description, title } = data;
    console.log(data,"datadata")
    let errors = {};
    let formValidCheck = true;

    const trimmedProjectName = projectName?.trim();
    const trimmedDescription = description?.trim();
    const trimmedTitle = title?.trim();

    if ((fieldName === 'projectName' || fieldName === '') && !trimmedProjectName) {
        errors.projectName = STRINGS.projectNameReq;
        formValidCheck = false;
    }

    if ((fieldName === 'description' || fieldName === '') && !trimmedDescription) {
        errors.description = STRINGS.descriptionReq;
        formValidCheck = false;
    }

    // if ((fieldName === 'title' || fieldName === '') && !trimmedTitle) {
    //     errors.title = STRINGS.addressReq;
    //     formValidCheck = false;
    // }

    return { formValidCheck, errors };
}
